export default "__VITE_ASSET__I8vgy2Nv__"